export default __webpack_public_path__ + "static/media/paper-bg.fea1a21e.svg";